/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { PureComponent } from 'react';
import { string, bool, shape } from 'prop-types';
import classNames from 'clsx';
import bowser from 'bowser';

import styles from './video-embed.scss';

/**
 * This is the VideoEmbed component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class VideoEmbed extends PureComponent {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    fullscreen: bool,
    oembed: string,
    desktop: shape({
      placeholder: string,
      src: string,
    }),
    mobile: shape({
      placeholder: string,
      src: string,
    }),
  };

  static defaultProps = {
    fullscreen: true,
    oembed: null,
    desktop: {},
    mobile: {},
  };

  componentDidMount() {
    this.setVideoAttributes();
  }

  componentDidUpdate() {
    this.setVideoAttributes();
  }

  setVideoAttributes() {
    if (this.video) {
      this.video.setAttribute('muted', 'true');
      this.video.setAttribute('playsinline', 'true');
      this.video.setAttribute('autoplay', 'true');
    }
  }

  renderVideo() {
    const { desktop, mobile, oembed } = this.props;
    const hasVideo = desktop && desktop.src && (mobile && mobile.src);

    if (oembed) {
      return (
        <iframe
          className={styles.iframe}
          src={oembed}
          frameBorder="0"
          allowFullScreen
        />
      );
    }

    if (hasVideo) {
      const videoUrl = bowser.mobile ? mobile.src : desktop.src;
      const videoPoster = bowser.mobile ? mobile.poster : desktop.poster;

      return (
        <video
          className={styles.video}
          autoPlay
          playsInline
          preload="meta"
          muted
          loop
          poster="data:image/gif,AAAA"
          ref={ref => {
            this.video = ref;
          }}
          style={{
            backgroundImage: `url(${videoPoster})`,
          }}
        >
          <source src={videoUrl} type="video/mp4" />
        </video>
      );
    }

    return null;
  }

  /**
   * Render VideoEmbed.
   *
   * @return {Object}
   */
  render() {
    const { fullscreen } = this.props;

    return (
      <div
        className={classNames(styles.wrapper, {
          [styles.fullscreen]: fullscreen,
        })}
      >
        {this.renderVideo()}
      </div>
    );
  }
}
